import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { webserveruserClient } from '#pplx_generated/typespec/rest/webserveruser/client.js';
export const refreshSubscriptionStatus = async ({ reason, }) => {
    try {
        const { error, data, response } = await webserveruserClient.GET('/rest/user/subscription/refresh', reason, {
            timeoutMs: getQueryTimeoutMs(),
            headers: { 'X-Perplexity-CSRF-Protection': '1' },
            // expensive query, not retrying
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                message: `Failed to refresh subscription status`,
                cause: error,
                status: response.status ?? 0,
            });
        }
        return data;
    }
    catch (err) {
        logger.error(err);
        return null;
    }
};
//# sourceMappingURL=refreshSubscriptionStatus.js.map